import React, { useState, useRef, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import config from '../../config';
import { useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PublishIcon from '@mui/icons-material/Publish';
import { BiSolidImageAdd } from "react-icons/bi";
function TabActivityLocation() {
  const [imageLocations, setImageLocations] = useState([]);
  const [fileFr, setFileFr] = useState(2);
  const fileInputRef = useRef(null);
  const { id, fac_id, years } = useParams();

  const [showImages, setShowImages] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const hasExistingImages = showImages.length > 0;
  const isUploadBlocked = isDisabled;

  useEffect(() => {
    fetchImageLos();
    fetchSystemOpen();
  }, [])

  const fetchSystemOpen = async () => {
    try {
      const yearAD = Number(years) - 543;
      const res = await axios.get(config.urlApi + `/activity/showPeriod/${fac_id}`);
      if (res.status === 200 && res.data.length > 0) {
        const currentPeriod = res.data.find((item) => Number(item.years) === yearAD);
        const isOpenRaw = currentPeriod?.is_open;
        const isOpen = isOpenRaw === true || isOpenRaw === 1 || isOpenRaw === '1';
        setIsDisabled(!isOpen);
      } else {
        setIsDisabled(true);
      }
    } catch (e) {
      console.log('fetchSystemOpen error:', e.message);
    }
  };

  const filterLatestActivityPeriod = (data) => {
    if (data.length === 0) return [];
  
    // ดึง activityperiod_id ของข้อมูลแรก (อัปเดตล่าสุด)
    const latestActivityPeriodId = data.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0].activityperiod_id;
  
    // เก็บเฉพาะข้อมูลที่มี activityperiod_id ตรงกับตัวแรก
    return data.filter(item => item.activityperiod_id === latestActivityPeriodId);
  };
  
  const fetchImageLos = async () => {
    try {
      const res = await axios.get(config.urlApi + `/images/ImageFr02/fac/${fac_id}`);
      if (res.status === 200) {
        if (res.data.length > 0) {
          const dataImage = filterLatestActivityPeriod(res.data);
          setShowImages(dataImage);
        }
      }

    } catch (error) {
      Swal.fire(
        {
          icon: 'error',
          title: 'error',
          text: error.message
        }
      )
    }
  }

  const handleFileSelectLo = (fileInput) => {
    const files = fileInput.current.files;
    if (files && files.length > 0) {
      if (imageLocations.length + files.length > 5) {
        Swal.fire({
          icon: 'warning',
          title: 'You can only upload up to 5 images.'
        });
        return;
      }

      const newImages = Array.from(files).map((file) => ({
        src: URL.createObjectURL(file),
        file: file,
      }));

      if (hasExistingImages) {
        Swal.fire({
          icon: 'warning',
          title: 'พบรูปภาพเดิมในระบบ',
          text: 'แนะนำให้ลบรูปเดิมก่อน หากต้องการแทนที่ กดยืนยันเพื่อเพิ่มรูปใหม่'
        });
      }

      setImageLocations((prevImages) => [...prevImages, ...newImages]);
    }
  };

  const handleImageRemove = (index) => {
    const filteredImages = imageLocations.filter((image, i) => i !== index);
    setImageLocations(filteredImages);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log('handleSubmit called, imageLocations length:', imageLocations.length);

    const formData = new FormData();
    for (const image of imageLocations) {
      formData.append('images', image.file);
    }
    formData.append('fileFr', fileFr);
    formData.append('activityperiod_id', id);
    formData.append('fac_id', fac_id);
    formData.append('year', years);

    try {
      const res = await Swal.fire({
        icon: 'question',
        title: 'เพิ่มรูป',
        text: 'คุณต้องการเพิ่มรูปใช่หรือไม่',
        showCancelButton: true
      });

      if (res.isConfirmed) {
        console.log('Uploading images, fileFr:', fileFr);
        const uploadRes = await axios.post(config.urlApi + '/images', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (uploadRes.status === 200) {
          setImageLocations([]);
          fetchImageLos();
          await Swal.fire({
            icon: 'success',
            title: 'สำเร็จ',
            text: 'บันทึกสำเร็จ"'
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'การอัปโหลดไม่สำเร็จ กรุณาลองใหม่"',
          });
        }
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message
      });
    }
  };

  const handleRemoveImg = async (imgId) => {
    const result = await Swal.fire({
      icon: "warning",
      title: "โปรดยืนยันการลบ",
      input: 'text',
      inputPlaceholder: 'ยืนยันพิมคำว่า YES',
      inputAttributes: {
        pattern: '^[Yy][Ee][Ss]$',
        maxlength: 3
      },
      confirmButtonColor: "#7a3",
      confirmButtonText: "Submit",
      showCancelButton: true,
      cancelButtonColor: "#b45e",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value || !value.match(/^[Yy][Ee][Ss]$/)) {
          return 'Please enter the correct value (YES).';
        }
      }
    });

    if (result.isConfirmed) {
      try {
        console.log('Deleting image with ID:', imgId);
        await axios.delete(config.urlApi + `/images/${imgId}`);
        await Swal.fire({
          icon: "success",
          title: "ลบข้อมูลสำเร็จ",
          timer: 800,
          timerProgressBar: true
        });
        await fetchImageLos();
        // คุณอาจต้องการทำการอัปเดต state เพื่อลบรูปภาพออกจากหน้าจอ
      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: error.message,
        });
      }
    }
  };
  


  return (
    <div>
      <div className="row">
        <ToastContainer />
        <h2 className='text-center'>ภาพประกอบพื้นที่และตำแหน่ง</h2>
        <div className="col-md-12 d-flex flex-column justify-content-center">
          {imageLocations.length < 5 && (
            <div className={`location-upload-box ${isUploadBlocked ? 'disabled' : ''}`}>
              <label htmlFor="fileInput" className='location-upload-box__label' onClick={() => {
                if (!isUploadBlocked && fileInputRef.current) {
                  fileInputRef.current.click();
                }
              }}>
                <span className="location-upload-box__icon"><BiSolidImageAdd size={64} /></span>
                <span className="location-upload-box__title">อัปโหลดภาพประกอบพื้นที่และตำแหน่ง</span>
                <span className="location-upload-box__subtitle">รองรับไฟล์ .png, .jpg, .jpeg, .svg (สูงสุด 5 รูป)</span>
                {hasExistingImages ? (
                  <span className="location-upload-box__warning">มีรูปภาพเดิมอยู่แล้ว กรุณากดลบรูปเดิมก่อนอัปโหลดใหม่</span>
                ) : (
                  <span className="location-upload-box__hint">คลิกเพื่อเลือกไฟล์รูปภาพ</span>
                )}
                <input
                  id="fileInput"
                  ref={fileInputRef}
                  type="file"
                  style={{ visibility: 'hidden', position: 'absolute', width: 0, height: 0 }}
                  multiple
                  onChange={() => handleFileSelectLo(fileInputRef)}
                  accept=".png, .jpg, .jpeg, .svg"
                  disabled={false}
                />
              </label>
            </div>
          )}
              
          <div className='box-preview-image'>
            {imageLocations.map((image, index) => (
              <div key={index} className='item-preview'>
                <button
                  type='button'
                  className='btn-remove'
                  onClick={() => handleImageRemove(index)}
                >
                  &#x2715;
                </button>
                <img
                  src={image.src}
                  alt={`Image ${index + 1}`}
                  className="img-fluid"
                />
              </div>
            ))}
          </div>
          {imageLocations.length > 0 && (
            <>
              <div className="d-flex justify-content-end my-3">
                <button className='btn btn-primary' disabled={isDisabled} onClick={handleSubmit}><PublishIcon /> บันทึรูปภาพ</button>
              </div>
              <hr />
            </>
          )}

          {showImages.length > 0 ? (
            <div className='box-preview-image-old mt-3'>
              {
                showImages.map((image) => (
                  <div key={image.id} className='item-preview item-preview-old'>
                    <button
                      type='button'
                      className='btn-remove'
                      onClick={() => handleRemoveImg(image.id)}
                    >
                      &#x2715;
                    </button>
                    <img
                      src={`${config.urlApi}/uploads/${image.file_name}`}
                      alt="Upload"
                      className="img-fluid"
                    />
                  </div>
                ))
              }
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}

export default TabActivityLocation;
